export default {"src":"/_next/static/media/TTSH.a39ef8d6.svg","height":18,"width":18};